import $ from "jquery";
import { debounce, getVh } from "../utils/functions";

const $window = $(window);
const $body = $("body");
const $pageBody = $(".page__body");
const $pageHeader = $(".page__header");
const $hamburger = $(".header__hamburger");
const $search = $(".search");
const $searchTrigger = $(".search__trigger");
const $searchWrapper = $(".search__wrapper");
const $searchClose = $(".search .search__close");
const $searchInput = $(".search .search__input");
const $searchContent = $(".search .search__content");

const toggleSearch = (filter) => {
  if ($search.hasClass("active")) {
    hideSearch(filter, true);
  } else {
    showSearch();
  }
};

const showSearch = () => {
  $search.addClass("active");
  $searchTrigger.addClass("active");
  $searchInput.val("");
  $searchInput.trigger("focus");
  $pageHeader.addClass("search-header");
};

const hideSearch = (filter, force = false) => {
  if ($search.hasClass("active")) {
    if (force === true) {
      $searchInput.val("");
    }
    if (!$searchInput.val()) {
      filter.page = 1;
      filter.search = $searchInput.val();
      reRenderSearch(filter);
      $search.removeClass("active");
      $searchTrigger.removeClass("active");
      $pageHeader.removeClass("search-header");
    }
    $searchTrigger.trigger("focus");
  }
};

const bindSearch = (filter) => {
  $searchInput.on(
    "input",
    debounce(function () {
      filter.search = $searchInput.val();
      reRenderSearch(filter);
    })
  );
};

const reRenderSearch = async (filter) => {
  if (filter.search === "") {
    filter.page = 1;
    $searchContent.html("").removeClass("search__content--active");
  } else {
    const data = await getSearchItems(filter);
    $searchContent.html(data.html);
    data.count != 0
      ? $searchContent.addClass("search__content--active")
      : $searchContent.removeClass("search__content--active");
  }
};

const getSearchItems = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + "/wp-json/mendelu/v1/search/html",
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const restrictSearchContent = () => {
  $searchContent.css(
    "max-height",
    `${Math.floor(100 * getVh() - $searchContent.offset().top - 50)}px`
  );
};

/* ------------------------------------------------------ */

const filter = {
  page: 1,
  search: $searchInput.val(),
  lang: $search.data("lang"),
};

restrictSearchContent();
$window.on("resize", debounce(restrictSearchContent, false, 500));
$pageBody.on("scroll", debounce(restrictSearchContent, false, 500));

$window.on(
  "resize:width",
  debounce(function () {
    hideSearch(filter);
  }, true)
);

$searchTrigger.on("click", function (event) {
  event.stopPropagation();
  toggleSearch(filter);
});
$searchWrapper.on("click", function (event) {
  event.stopPropagation();
});
$body.on("click", function () {
  hideSearch(filter);
});
$hamburger.on("click", function () {
  hideSearch(filter, true);
});
$searchClose.on("click", function () {
  hideSearch(filter, true);
});
$window.on("keydown", function (e) {
  if ($search.hasClass("active")) {
    if (e.key === "Tab") {
      e.preventDefault();
    } else if (e.key === "Escape") {
      hideSearch(filter, true);
    }
  }
});
bindSearch(filter);
